import React, { useState } from "react";
import Header from "../../../Components/HeaderAdmin/Header";
import { Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import { StagingStAdd } from "../../../Api/StagingSt";

function ShipStationAdd() {
    const [station_name, setStation_name] = useState('');
    const [stationId, setStationId] = useState('');

    const handleAddbuildST = (e) => {
        e.preventDefault();

        const data = {
            Staging_Stations_name: station_name,
            Staging_Stations_id: stationId
        };

        StagingStAdd(data)
            .then((res) => {
               
                if (res?.code === 200) {
                    const Data = res.data.data;
                    alert("Station details Add successfully.");
                    setStation_name("");
                    setStationId("");
                } else {
                    alert(res.data?.message);
                }
                
            })
            .catch((err) => {
                alert("Error occurred: " + err);
                console.error("Error:", err);
            });
    };

    return (
        <>
            <div className="main-page-body-content-header">
                <Header />
            </div>
            <div className="dashboard-container d-flex">
                <div className="main-container">
                    <div className="main-page-body-content">
                        <div className="main-page-body-content-body">
                            <div className="main-page-body-content-body-container">
                                <div className="container-fluid">
                                    <div className="sec-header-dash">
                                        <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                            <h3>Station Add</h3>
                                        </div>
                                    </div>
                                    <div className="dashboard-sec">
                                        <div className="container-fulid">
                                            <Form onSubmit={handleAddbuildST}>
                                                <fieldset>
                                                    <div className="form-box-section mt-4">
                                                        <div className="form-box-inner">
                                                            <div className="form-item">
                                                                <div className="form-group custom-form-group">
                                                                    <div className="col-md-6">
                                                                        <label className="dashboard-form-lable">Station ID</label>
                                                                    </div>
                                                                    <input
                                                                        type="text"
                                                                        placeholder="Id"
                                                                        required
                                                                        className="form-control dashboard-input-box-1 me-1 w-100"
                                                                        value={stationId}
                                                                        onChange={(e) => setStationId(e.target.value)}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="form-item">
                                                                <div className="form-group custom-form-group mb-0">
                                                                    <div className="col-md-6">
                                                                        <label className="dashboard-form-lable">Station Name</label>
                                                                    </div>
                                                                    <input
                                                                        type="text"
                                                                        placeholder="Station Name"
                                                                        required
                                                                        className="form-control dashboard-input-box-1 me-1"
                                                                        value={station_name}
                                                                        onChange={(e) => setStation_name(e.target.value)}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="sec-btn-group mt-4">
                                                        <div></div>
                                                        <button className="btn btn-save" type="submit">Save</button>
                                                    </div>
                                                </fieldset>
                                            </Form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ShipStationAdd;
